import { Badge as BadgeCapsules, BadgeProps } from "@mantine/core";
import { IColor, variantColors } from "../../../utils/selectColors";

interface IProps extends BadgeProps {
  colorTag?: IColor;
  border?: boolean;
}

const TagCapsules = ({ colorTag, border, ...props }: IProps) => {
  const colorSelected: IColor = !!colorTag ? colorTag : IColor.green;
  const selectedVariant = variantColors[colorSelected];

  return (
    <BadgeCapsules
      styles={{
        root: {
          width: "fit-content",
          padding: "4px 8px",
          height: "30px",
          fontSize: "12px",
          background: selectedVariant.bg,
          color: selectedVariant.color,
          border: "1px solid",
          borderColor: border ? selectedVariant.borderColor : "transparent",
        },
        inner: {
          fontWeight: 500,
          lineHeight: "14px",
          textAlign: "center",
        },
      }}
      radius={20}
      {...props}
    />
  );
};

export default TagCapsules;
